import angular from 'angular';
import uiRouter from 'angular-ui-router';
import newsItemComponent from './newsItem.component';
import _ from 'lodash';

let newsItemModule = angular.module('newsItem', [uiRouter])
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider
      .state('apps.digitalAgenda.show', {
        url: '/:newsId',
        component: 'newsItem',
        resolve: {
          news: ($stateParams, AppsService) => AppsService.digitalAgenda()
            .then(news => _.find(news, {'ID': parseInt($stateParams.newsId)})),
          $title: (news) => `Agenda Digitale - ${news.post_title}`
        }
      })
      .state('apps.projectManager.list.show', {
        url: '/:newsId',
        component: 'newsItem',
        resolve: {
          news: ($stateParams, AppsService) => AppsService.projectManager($stateParams.issueId)
            .then(news => _.find(news, {'ID': parseInt($stateParams.newsId)})),
          $title: (news) => `Progetto Manager - ${news.post_title}`
        }
      });
  })
  .component('newsItem', newsItemComponent)
  .name;

export default newsItemModule;



// WEBPACK FOOTER //
// ./client/app/components/apps/newsItem/newsItem.js